{
    "version": 8,
    "name": "FE-Hybrid",
    "metadata": { "maputnik:renderer": "mlgljs" },
    "sources": {
        "raster-tiles": {
            "attribution": "<a target='_blank' href='https://www.esri.com/en-us/legal/terms/data-attributions'>Esri</a>, Maxar, Earthstar Geographics",
            "maxzoom": 23,
            "tiles": [
                "https://maps.geo.us-west-2.amazonaws.com/maps/v0/maps/femapsatellite/tiles/{z}/{x}/{y}?key=v1.public.eyJqdGkiOiI0MTE1ZmJmYy00ZTI3LTRjYjItYTdhYS0wNzA4MDIyNmZhMTMifTvYSG_PwsLei6wX9KG1-VZGIqkKWuE9fVwcM8QJHIlDpq1j7LGBXExqQYZ8svTwPCayfpfc48IqFzJewjgWOuOxSEj9lEAxVwO7co3yGMwTyc7btg58ZmG6FjOYD5FEjoryGs6jtKRnj1bt025LDJgSEdIVWIUHs9x73P0s4eHD5ACNL1t_2No80s2VJ4vEHAPaY1ZxFsOWHrCeRrEUDIx_7tqAE7ZB2_6NpxrgZSt7pr53GANBbE6b-yt2a6kggGYyecE62AlxoSdyWI4qYgX8x9-uDespmWqsqecj8ln7AbMTIy25eQyNjNKCgjAs0_p-V-PP5TCsNmfz8ixNRBc.MGFjMDA4ZmUtYWRiYy00NTgyLTg0Y2MtZTY3MzFlZDRmYTQ1"
            ],
            "type": "raster",
            "tileSize": 256
        },
        "febase": {
            "type": "vector",
            "tiles": ["https://dhpfl5h9i14m7.cloudfront.net/FEBase-A-YYYYMMDD/{z}/{x}/{y}.mvt"],
            "minzoom": 0,
            "maxzoom": 14,
            "attribution": "<a target='_blank' href='https://openstreetmap.org/copyright'>OpenStreetMap</a>"
        },
        "terrain_source": {
            "type": "raster-dem",
            "encoding": "terrarium",
            "tiles": ["https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png"],
            "tileSize": 256,
            "minzoom": 0,
            "maxzoom": 14
        }
    },
    "sprite": [
        {
            "id": "fe",
            "url": "static/map/CAEFESprite"
        }
    ],
    "sky": {
        "sky-color": "#88C6FC",
        "sky-horizon-blend": 0.8,
        "horizon-color": "#ffffff",
        "horizon-fog-blend": 0.8,
        "fog-color": "#ffffff",
        "fog-ground-blend": 0.5,
        "atmosphere-blend": 0
    },
    "light": {
        "anchor": "viewport",
        "position": [0, 210, 30],
        "color": "#ffffff",
        "intensity": 0
    },
    "state": {
        "text-color": { "default": "white" },
        "feNav_icon-color": { "default": "rgba(240,240,240,1)" },
        "feNav_text-color": { "default": "rgba(240,240,240,1)" },
        "feNav_line-color": { "default": "rgba(0,0,0,1)" },
        "feNav_icon-color_awy_def": { "default": "rgba(0,0,0,1)" },
        "feNav_line-color_awy_def": { "default": "rgba(0,0,0,1)" },
        "feNav_text-color_awyl": { "default": "rgba(255,255,255,1)" },
        "feNav_line-color_mor": { "default": "rgb(140,140,140)" },
        "feNav_line-color_overwater": { "default": "rgba(65,105,225,0.7)" },
        "feNav_text-color_mor_def": { "default": "rgba(0,170,0,1)" },
        "feNav_text-color_aspl": { "default": "rgb(21,23,94)" },
        "feNav_text-color_sual": { "default": "rgb(21,23,94)" },
        "feNav_text-color_hldl": { "default": "rgb(240,240,240)" }
    },
    "layers": [
        { "id": "tiles", "type": "raster", "source": "raster-tiles" },
        {
            "id": "boundary_state",
            "type": "line",
            "metadata": { "mapbox:group": "a14c9607bc7954ba1df7205bf660433f" },
            "source": "febase",
            "source-layer": "boundary",
            "minzoom": 2,
            "filter": ["==", "admin_level", 4],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-blur": 0.4,
                "line-color": "rgb(230, 204, 207)",
                "line-dasharray": [2, 2],
                "line-opacity": 1,
                "line-width": {
                    "base": 1.3,
                    "stops": [
                        [3, 1],
                        [22, 15]
                    ]
                }
            }
        },
        {
            "id": "boundary_country_z0-4",
            "type": "line",
            "metadata": { "mapbox:group": "a14c9607bc7954ba1df7205bf660433f" },
            "source": "febase",
            "source-layer": "boundary",
            "maxzoom": 5,
            "filter": ["all", ["==", "admin_level", 2], ["!has", "claimed_by"]],
            "layout": { "line-cap": "round", "line-join": "round" },
            "paint": {
                "line-blur": {
                    "base": 1,
                    "stops": [
                        [0, 0.4],
                        [22, 4]
                    ]
                },
                "line-color": "rgb(230, 204, 207)",
                "line-opacity": 1,
                "line-width": {
                    "base": 1.1,
                    "stops": [
                        [3, 1],
                        [22, 20]
                    ]
                }
            }
        },
        {
            "id": "boundary_country_z5-",
            "type": "line",
            "metadata": { "mapbox:group": "a14c9607bc7954ba1df7205bf660433f" },
            "source": "febase",
            "source-layer": "boundary",
            "minzoom": 5,
            "filter": ["==", "admin_level", 2],
            "layout": { "line-cap": "round", "line-join": "round" },
            "paint": {
                "line-blur": {
                    "base": 1,
                    "stops": [
                        [0, 0.4],
                        [22, 4]
                    ]
                },
                "line-color": "rgb(230, 204, 207)",
                "line-opacity": 1,
                "line-width": {
                    "base": 1.1,
                    "stops": [
                        [3, 1],
                        [22, 20]
                    ]
                }
            }
        },
        {
            "id": "place_city_large",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "minzoom": 4,
            "maxzoom": 12,
            "filter": ["all", ["==", "$type", "Point"], ["<=", "rank", 3], ["==", "class", "city"]],
            "layout": {
                "icon-image": {
                    "base": 1,
                    "stops": [
                        [0, "fe:circle-11"],
                        [9, ""]
                    ]
                },
                "icon-size": 0.4,
                "text-anchor": {
                    "base": 1,
                    "stops": [
                        [0, "left"],
                        [8, "center"]
                    ]
                },
                "text-field": "{name:latin}\n{name:nonlatin}",
                "text-font": ["Noto Sans Bold"],
                "text-justify": "left",
                "text-offset": [0.5, 0.2],
                "text-size": 14,
                "text-transform": "none",
                "visibility": "visible"
            },
            "paint": {
                "icon-opacity": 0.7,
                "text-color": "rgb(121,121,121)",
                "text-halo-blur": 0,
                "text-halo-color": "rgba(0,0,0,1)",
                "text-halo-width": 1
            }
        }
    ],
    "created": "2021-06-01T00:00:00Z",
    "modified": "2021-06-01T00:00:00Z",
    "id": "FE-Satellite"
}
